import axios from "axios";
import { DataGrid, Button, Box } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Export,
  FilterRow,
  HeaderFilter,
  Item,
  LoadPanel,
  MasterDetail,
  Pager,
  Paging,
  SearchPanel,
  StateStoring,
  Toolbar,
} from "devextreme-react/data-grid";

import { Item as BoxItem } from "devextreme-react/box";
import jsPDF from "jspdf";
import "jspdf-autotable";
import React, { useEffect, useState } from "react";

import { malgun } from "../malgun";

import { exportDataGrid as exportDataGridToPDF } from "devextreme/pdf_exporter";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";
import MdcinClincTestInfoService01Grid from "./MdcinClincTestInfoService01Grid";
import MdcinClincTestInfoService01VectorMapBubble from "./MdcinClincTestInfoService01VectorMapBubble";
import MdcinClincTestInfoService01PieChart from "./MdcinClincTestInfoService01PieChart";
import HospURL from "./HospURL";
import Header from "../../common/Header";

export default function ClinicTestOprtnInsttInfoService01() {
  const [dataSource, setDataSource] = useState(null);
  const [sido, setSido] = useState(null);
  const [blind, setBlind] = useState(false);

  const dataGridRef = React.createRef();
  const pageSize = [10, 20, 50, 100];

  useEffect(() => {
    document.title = "의약품임상시험 실시기관 정보";

    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/clinicTestOprtnInsttInfoService01`
      )
      .then((result) => {
        setDataSource(result.data);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/clinicTestOprtnInsttInfoService01?sido=${sido}`
      )
      .then((result) => {
        setDataSource(result.data);
      });
  }, [sido]);

  const exportGrid = React.useCallback(() => {
    const doc = new jsPDF("l", "mm", [297, 210]);

    doc.addFileToVFS("malgun.ttf", malgun);
    doc.addFont("malgun.ttf", "malgun", "normal");
    doc.setFont("malgun");

    const dataGrid = dataGridRef.current.instance;

    exportDataGridToPDF({
      jsPDFDocument: doc,
      component: dataGrid,
      autoTableOptions: {
        styles: {
          font: "malgun",
        },
      },
    }).then(() => {
      doc.save("식품의약품안전처_의약품 임상시험 정보.pdf");
    });
  });

  const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("의약품임상시험 실시기관 정보");

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], {
            type: "application/octet-stream",
          }),
          "식품의약품안전처_의약품임상시험 실시기관 정보.xlsx"
        );
      });
    });

    e.cancel = true;
  };

  const linkClinicalTrialsGov = React.useCallback(() => {
    window.open(`https://clinicaltrials.gov`);
  });

  const handleBlind = () => {
    setBlind(!blind);
  };

  const renderDetail = (props) => {
    return <MdcinClincTestInfoService01Grid {...props} blind={blind} />;
  };

  return (
    <React.Fragment>
      {/* <h1
        style={{
          color: "#1B4452",
          marginBlockStart: "0.67em",
          marginBlockEnd: "0.67em",
          marginInlineStart: "0px",
          marginInlineEnd: "0px",
        }}
      >
        식품의약품안전처 의약품임상시험 실시기관 정보
      </h1> */}
      <Header
        // title={"식품의약품안전처 의약품임상시험 실시기관 정보"}
        title="NEW DRUG CLINICAL TRIAL INSTITUTION INFO."
        menuDataSource={null}
      />
      <hr style={{ border: "0.5px solid #e0e0e0" }} />
      {/* <MdcinClincTestInfoService01VectorMap /> */}
      <Box direction="row" width="100%">
        <BoxItem ratio={1}>
          {<MdcinClincTestInfoService01VectorMapBubble setSido={setSido} />}
        </BoxItem>
        <BoxItem ratio={1}>
          {<MdcinClincTestInfoService01PieChart sido={sido} />}
        </BoxItem>
      </Box>
      <hr style={{ border: "0.5px solid #e0e0e0" }} />
      {dataSource && (
        <DataGrid
          id="ClinicTestOprtnInsttInfoService01"
          ref={dataGridRef}
          dataSource={dataSource}
          keyExpr="LAB_SEQ"
          rowAlternationEnabled={true}
          showBorders={true}
          showColumnLines={true}
          allowColumnResizing={true}
          focusedRowEnabled={true}
          onExporting={onExporting}
        >
          <ColumnChooser enabled={true} />
          <LoadPanel enabled={true} />

          <FilterRow visible={true} />
          <HeaderFilter visible={true} />

          <SearchPanel visible={true} highlightCaseSensitive={true} />

          <Paging enabled={true} />

          <StateStoring
            enabled={true}
            type="localStorage"
            storageKey={"ClinicTestOprtnInsttInfoService01"}
          />

          <Column
            dataField="LAB_NAME"
            caption="실시기관명"
            dataType="string"
            width={250}
            // cellRender={HospURL}
          />
          <Column
            dataField={"TOTAL"}
            caption="Total"
            dataType={"number"}
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="0상"
            caption="0상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="1/2상"
            caption="1/2상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="1/2a상"
            caption="1/2a상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="1/3상"
            caption="1/3상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="1상"
            caption="1상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="1b상"
            caption="1b상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="2/3상"
            caption="2/3상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="2상"
            caption="2상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="2a상"
            caption="2a상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="2b/3상"
            caption="2b/3상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="2b상"
            caption="2b상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="3/4상"
            caption="3/4상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="3상"
            caption="3상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="3a상"
            caption="3a상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="3b상"
            caption="3b상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="4상"
            caption="4상"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="생동"
            caption="생동"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="연구자 임상시험"
            caption="연구자 임상시험"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column
            dataField="연장"
            caption="연장"
            dataType="number"
            allowFiltering={false}
            allowHeaderFiltering={false}
          />
          <Column caption="Hosp." cellRender={HospURL} width={70} />

          <Toolbar>
            <Item location="after">
              <Button icon="blind.png" onClick={handleBlind} />
            </Item>
            <Item location="after">
              <Button
                // icon="https://clinicaltrials.gov/ct2/html/images/favicon.ico"
                icon="https://clinicaltrials.gov/assets/favicons/favicon.svg"
                // text="ClinicalTrials.gov"
                onClick={linkClinicalTrialsGov}
              />
            </Item>
            <Item location="after">
              <Button icon="exportpdf" onClick={exportGrid} />
            </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
            <Item name="searchPanel" />
          </Toolbar>

          <Export enabled={true} />

          <MasterDetail
            enabled={true}
            // component={MdcinClincTestInfoService01Grid}
            render={renderDetail}
          />

          <Pager
            allowedPageSizes={pageSize}
            showPageSizeSelector={true}
            showInfo={true}
          />
          <Paging defaultPageSize={10} />
        </DataGrid>
      )}
    </React.Fragment>
  );
}
